import React, { useState, useEffect, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import SidebarSolicitante from '../Components/Sidebar/Sidebar';
import api from '../apiClient';

import '../theme/solicitante-theme.css';
import './historicoSatiFechada.css';
import Anexo from '../Components/Popup/Anexos/popAnexos';
import Timeline from '../Components/Timeline/Timeline';
import { useStatusChamado } from '../../hooks/useStatusChamado';
import StatusBadge from '../Components/StatusBadge/StatusBadge';
import AvaliacaoSolicitante from '../Components/Avaliacao/AvaliacaoSolicitante';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoTokenSolicitante from '../../FuncoesGerais/VerificarTokenSolicitante';

function HistoricoSatiFechadaSolicitante(props) {
    const history = useHistory();
    const id = props.match.params.id;
    const { statusList } = useStatusChamado();

    const [data, setData] = useState([]);
    const [satDesSol, setSatDesSol] = useState('');
    const [statusNome, setStatusNome] = useState('');
    const [statusVal, setStatusVal] = useState(null);
    const [tipoNome, setTipoNome] = useState('');
    const [atendenteNome, setAtendenteNome] = useState('');
    const [dataAbertura, setDataAbertura] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isAnexoOpen, setAnexoOpen] = useState(false);

    const verificar = useCallback(async () => {
        const resultado = await verificandoApp('SOLICITANTE');
        if (!resultado) {
            history.push('/');
            return;
        }
        await verificandoTokenSolicitante(history);
    }, [history]);

    const fetchData = useCallback(async () => {
        try {
            const response = await api.post('/api/conHistoricoSATI', { satNum: id });
            const lista = Array.isArray(response.data) ? response.data : [];
            setData(lista.map((item) => ({
                descricao: item.SATDESSLI,
                data: item.SATDATFEC,
                autor_nome: item.autor_nome || null,
            })));
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setData([]);
        }
    }, [id]);

    const fetchComp = useCallback(async () => {
        try {
            const response = await api.post('/api/satComp', { satNum: id });
            const row = Array.isArray(response.data) ? response.data[0] : null;
            if (row && row.SATNUM > 0) {
                setSatDesSol(row.SATDESSOL ?? '');
                const rawStatus = (row.status_nome ?? '').toString().trim();
                setStatusNome(rawStatus && !/^\d+$/.test(rawStatus) ? rawStatus : '');
                setStatusVal(row.SATSTASAI ?? null);
                setTipoNome(row.tipo_nome ?? '');
                setAtendenteNome((row.atendente_nome ?? '').toString().trim());
                setDataAbertura(row.SATDATSOL ?? null);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, [id]);

    useEffect(() => {
        verificar();
        setLoading(true);
        Promise.all([fetchData(), fetchComp()]).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const dataAberturaFmt = dataAbertura
        ? new Date(dataAbertura).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
        : null;

    return (
        <div className="app-layout">
            <SidebarSolicitante />
            <main className="main-content sol-page">
                <div className="sol-container hist-fechada">
                    <Link to="/Solicitante/satiFechada" className="sol-back">
                        <i className="fas fa-arrow-left" /> Voltar para o histórico
                    </Link>

                    <header className="hist-fechada-header sol-card">
                        <div className="hist-fechada-header-top">
                            <div>
                                <span className="hist-fechada-num">Chamado #{id}</span>
                                {tipoNome && <span className="hist-fechada-tipo">{tipoNome}</span>}
                            </div>
                            <StatusBadge statusVal={statusVal} statusList={statusList} fallback={statusNome || 'Finalizado'} />
                        </div>
                        <div className="hist-fechada-meta">
                            {dataAberturaFmt && <span><i className="fas fa-calendar-alt" /> Aberto em {dataAberturaFmt}</span>}
                            <span><i className="fas fa-user-headset" /> {atendenteNome || 'Não atribuído'}</span>
                        </div>
                    </header>

                    <div className="hist-fechada-grid">
                        <section className="sol-card hist-fechada-card">
                            <h2 className="hist-fechada-card-title"><i className="fas fa-align-left" /> Descrição do chamado</h2>
                            {loading ? (
                                <>
                                    <div className="sol-skeleton sol-skeleton--text" style={{ width: '92%' }} />
                                    <div className="sol-skeleton sol-skeleton--text" style={{ width: '80%' }} />
                                    <div className="sol-skeleton sol-skeleton--text" style={{ width: '60%' }} />
                                </>
                            ) : (
                                <p className="hist-fechada-desc">{satDesSol || 'Sem descrição.'}</p>
                            )}
                            <button onClick={() => setAnexoOpen(true)} className="sol-btn sol-btn--soft" type="button" style={{ marginTop: '1rem' }}>
                                <i className="fas fa-paperclip" /> Ver anexos
                            </button>
                            {isAnexoOpen && <Anexo numeroSati={id} isOpen={isAnexoOpen} onClose={() => setAnexoOpen(false)} />}
                        </section>

                        <section className="sol-card hist-fechada-card">
                            <h2 className="hist-fechada-card-title"><i className="fas fa-stream" /> Histórico de atendimento</h2>
                            {loading ? (
                                <>
                                    <div className="sol-skeleton sol-skeleton--text" style={{ width: '70%' }} />
                                    <div className="sol-skeleton sol-skeleton--text" style={{ width: '90%' }} />
                                    <div className="sol-skeleton sol-skeleton--text" style={{ width: '50%' }} />
                                </>
                            ) : (
                                <Timeline eventos={data} />
                            )}
                        </section>
                    </div>

                    <AvaliacaoSolicitante satNum={id} />
                </div>
            </main>
        </div>
    );
}

export default HistoricoSatiFechadaSolicitante;
